import React,{useEffect,useState} from 'react';
import { Collapse ,Button,BackTop} from 'antd';
import {ChartNP,Loader,Party} from '../index';
import { useParams ,Link} from 'react-router-dom';
import HTMLReactParser from 'html-react-parser';
import axios from 'axios';
import i18next from 'i18next';
import './SeatsDetail.css';
import {VerticalAlignTopOutlined } from '@ant-design/icons'
import {Johor,Kedah,Kelantan,KL,Melaka,Sembilan,Pahang,Penang,Perak,Perlis,Sabah,Sarawak,Selangor,Terengganu} from '../../map';
import { Gpt } from 'react-gpt-ads';
import zhConvertor from 'zhconvertor';

const {Panel}=Collapse;
const SeatsDetail = () => {
  
  const {parliment,state}=useParams();
  const [seatCode,setSeatCode]=useState(parliment);
  const [data,setData]=useState([]);
  const [expandAll,setExpandAll]=useState(false);
  const [done,setDone]=useState(undefined);
  const [isOfficial,setIsOfficialResult]=useState(true);
  const [seat,setSeat]=useState('');

  const fetchData = async(state,seatCode)=>{
    try{
      axios.get(`seatinfo.php?seat=${state}&code=${seatCode}`).then((response)=>{
        const datas=response.data
        
        setData(datas);
        setDone(true);

        // for each candidate, check if they are official, if one of them is not official, then the result is not official, break the loop after setIsOfficialResult(false)

        for(let i = 0; i < datas.length; i++){
          if(datas[i].is_o == 0){
            setIsOfficialResult(false);
            // break if one of the candidate is not official
            break;
          }
        }

        return datas;
      })
    }catch(error){
      console.log(error)
    }
  }
  //expand
  const activeKey=()=>{
      const arr=[];
      for (let i=0 ;i<data.length;i++){
         arr[i]=i;
      }
      setSeat(arr);
    
  }
  const expandFunctions=()=>{
    setExpandAll(!expandAll);
    if(expandAll===true){
      const arr=[];
      for (let i=0 ;i<data.length;i++){
        arr[i]=i;
      }
      setSeat(arr);
    }else{
      setSeat([]);
    }
  }
  //end expand

  useEffect(()=>{
    window.scrollTo(0, 0)
    setSeatCode(parliment)
    fetchData(state,seatCode)
    parlimentStateFunction()
    //console.log('Fetching')
    const interval=setInterval(()=>{
      fetchData(state,seatCode)
    },15000)
    //return ()=>clearInterval(interval)
  },[state,seatCode,parliment])


useEffect(()=>{
  if(data&&expandAll===false){
    activeKey()
  }
},[data])

  const convertName = (state) => {
    switch (state) {
      case "johor":
        state = "柔佛";
        return state;
        
      case "kedah":
        state = "吉打" + "（36 席）";
        return state;
        
      case "penang":
        state = i18next.t("槟城") + "（40 席）";
        return state;
        
      case "kelantan":
        state = i18next.t("吉兰丹") + "（45 席）";
        return state;

      case "melaka":
        state = i18next.t("马六甲");
        return state;
        
      case "negerisembilan":
        state = i18next.t("森美兰") + "（36 席）";
        return state;
        
      case "selangor":
        state = i18next.t("雪兰莪") + "（56 席）";
        return state;
        
      case "sabah":
        state = "沙巴";
        return state;
        
      case "terengganu":
        state = i18next.t("登嘉楼") + "（32 席）";
        return state;
        
      case "sarawak":
        state = i18next.t("砂拉越");
        return state;
        
      case "perlis":
        state = i18next.t("玻璃市");
        return state;
        
      case "perak":
        state =i18next.t("霹雳");
        return state;
        
      case "pahang":
        state = "彭亨";
        return state;
        
      case "kl":
        state =i18next.t("联邦直辖区");
        return state;
        
      default:
        state = "error";
        return state;
    }
  };
  const parlimentStateFunction=(e)=>{
    setExpandAll(false);
  }

  const getBgColorByParty=(party)=>{
    switch(party){
      case 'bn':
        return '#1b348e';
      case 'ph':
        return '#f9140d';
      case 'pn':
        return '#038901';
      case 'grs':
        return '#9eecff';
      case 'warisan':
        return '#383838ad';
      default:
        return '#ffff00';
    }
  }

  const getStatusById = (id) => {
    id = parseInt(id);
    switch(id){
      case 1:
        return i18next.t('当选');
      case 2:
        return i18next.t('失按柜金');
      case 3:
        return i18next.t('不战而胜');
      case 4:
        return i18next.t('退选');
      default:
        return ""
    }
  }
  
  // const loadComponent=(name)=>{
  //   const Component=React.lazy(()=>
  //      import (`../../map/${name}`)
  //   );
  //   return Component
  // }
  // const Component=loadComponent(state)
  
  const topStyle={
    height: 48,
    width: 48,
    lineHeight: '48px',
    borderRadius: 20,
    backgroundColor: 'red',
    color: '#fff',
    textAlign: 'center',
    fontSize: 20,
  }

  if (!done) return <Loader/>;
  
  return (
    <> 
      <div className="div_main">
        <div className='title_seat'>
          <h1 className='title'>{convertName(state)}</h1>
          {
            /*
            !isOfficial &&
              <h3>{localStorage.getItem('lang') != 'zh_TW' ?zhConvertor.t2s("非正式成绩") : "非正式成绩"}</h3>
              */
             
          }
        </div>
        {/*
        <div className='button_expand'>
          <Button type="primary" value="p" danger size='large' onClick={parlimentStateFunction} style={{marginRight:'10px',zIndex:'10'}}><Link to={`../seats/${state}/p`}>国会议席</Link></Button>
          {(state==='pahang' || state==='perlis' || state==='perak') &&<Button type="primary" value="n" style={{zIndex:'10'}}danger size='large' onClick={parlimentStateFunction}><Link to={`../seats/${state}/n`}>州议席</Link></Button>}
        </div>
         */}
        <div className='chartNP'> 
          <ChartNP state={state} code={seatCode}/>
        </div>
        <div className='table_party'>
          <Party/>
        </div>
        <Gpt 
              adUnit="/2163006/election2023_top"
              name="div-gpt-ad-1666944904129-0"
              size={[[300, 250],[336, 280], 'fluid']}
          />
        <div className='seat_map'>
          <h1>{convertName(state)+"-地图"}</h1>
          <div className='map'>
            {state==='johor'&&<Johor code={seatCode} state={state}/>}
            {state==='kedah'&&<Kedah code={seatCode} state={state}/>}
            {state==='kelantan'&&<Kelantan code={seatCode} state={state}/>}
            {state==='kl'&&<KL code={seatCode} state={state}/>}
            {state==='melaka'&&<Melaka code={seatCode} state={state}/>}
            {state==='negerisembilan'&&<Sembilan code={seatCode} state={state}/>}
            {state==='pahang'&&<Pahang code={seatCode} state={state}/>}
            {state==='penang'&&<Penang code={seatCode} state={state}/>}
            {state==='perak'&&<Perak code={seatCode} state={state}/>}
            {state==='perlis'&&<Perlis code={seatCode} state={state}/>}
            {state==='sabah'&&<Sabah code={seatCode} state={state}/>}
            {state==='sarawak'&&<Sarawak code={seatCode} state={state}/>}
            {state==='selangor'&&<Selangor code={seatCode} state={state}/>}
            {state==='terengganu'&&<Terengganu code={seatCode} state={state}/>}
          </div>
        </div>
        <div className='button_expand'>
          <Button type="primary"  style={{backgroundColor:'grey',borderRadius:'10px',borderColor:'white'}}  onClick={expandFunctions}>{expandAll ? '显示全部 ' : '隐藏全部'} </Button>
        </div>
        <div className='seat_info'>
            {data.map((cand,index)=>
              {
                return <section id={"s"+cand.seatname} key={index}>
                  {index%10 == 0 && index != 0 &&
                    <div style={{margin:'1em auto',textAlign:'center'}}>
                      <Gpt 
                        adUnit="/2163006/election_336x280_300x250"
                        name={`div-gpt-ad-middle-${index}`}
                        size={[[300, 250],[336, 280], 'fluid']}
                      />
                    </div>
                  }
                  <Collapse activeKey={seat} onChange={setSeat} key={index} className='collapse_seat' >
                    <Panel className='panel_seat' header={cand.seatname +"  "+ cand.ednamec +" "+ cand.edname} key={index} >
                      {
                        cand.is_o == "0" && parseInt(cand.total_votes) > 0 &&
                        <h3 className="hint_unofficial">*{localStorage.getItem('lang') != 'zh_TW' ?zhConvertor.t2s("非官方成績") : "非官方成績"}</h3>
                      }
                    {/*HTMLReactParser(cand.candidate+cand.majority+cand.total_votes+cand.electorate+cand.reg_percent+cand.last_result)
                    HTMLReactParser(cand.candidate+cand.majority+cand.total_votes+cand.electorate+cand.reg_percent)*/}
                    {cand.showinfo === true ? 
                      <>
                      <div className="seat_info_grid">
                        <div className="seat_info_left">
                          {localStorage.getItem('lang') != 'zh_TW' ?zhConvertor.t2s("选民人数") : "选民人数"}
                        </div>
                        <div className="seat_info_right">
                          {parseInt(cand.electorate).toLocaleString()}
                        </div>
                      </div>
                      <div className="seat_info_grid">
                        <div className="seat_info_left">
                          {localStorage.getItem('lang') != 'zh_TW' ?zhConvertor.t2s("选民结构") : "选民结构"}
                        </div>
                        <div className="seat_info_right">
                          {parseInt(cand.reg_percent.malay) > 0 && (
                            <span className="info_numbers">
                              {localStorage.getItem('lang') !== 'zh_TW' 
                                ? `${zhConvertor.t2s("巫裔")}: ` 
                                : "巫裔: "}
                              {cand.reg_percent.malay}%
                            </span>
                          )}
                          {parseInt(cand.reg_percent.cina) > 0 && (
                            <span className="info_numbers">
                              {localStorage.getItem('lang') !== 'zh_TW' 
                                ? `${zhConvertor.t2s("华裔")}: ` 
                                : "华裔: "}
                              {cand.reg_percent.cina}%
                            </span>
                          )}
                          {parseInt(cand.reg_percent.india) > 0 && (
                            <span className="info_numbers">
                              {localStorage.getItem('lang') !== 'zh_TW' 
                                ? `${zhConvertor.t2s("印裔")}: ` 
                                : "印裔: "}
                              {cand.reg_percent.india}%
                            </span>
                          )}
                          {parseInt(cand.reg_percent.bpsabah) > 0 && (
                            <span className="info_numbers">
                              {localStorage.getItem('lang') !== 'zh_TW' 
                                ? `${zhConvertor.t2s("沙巴土著")}: ` 
                                : "沙巴土著: "}
                              {cand.reg_percent.bpsabah}%
                            </span>
                          )}
                          {parseInt(cand.reg_percent.lain) > 0 && (
                            <span className="info_numbers">
                              {localStorage.getItem('lang') !== 'zh_TW' 
                                ? `${zhConvertor.t2s("其他")}: ` 
                                : "其他: "}
                              {cand.reg_percent.lain}%
                            </span>
                          )}
                        </div>
                      </div>
                      </>
                    : null}
                    {cand.candidate.length > 0 &&
                      <div className="seat_info_grid">
                        <div className="seat_info_left">
                          {localStorage.getItem('lang') != 'zh_TW' ?zhConvertor.t2s("投票情况") : "投票情况"}
                        </div>
                        <div className="seat_info_right">
                          {parseInt(cand.total_votes) > 0 && (
                            <>
                              <span className="info_numbers">
                                {localStorage.getItem('lang') != 'zh_TW' ?zhConvertor.t2s("投票人数") : "投票人数"}: {cand.total_votes.toLocaleString()} 
                                {parseFloat(cand.percentage) > 0 && 
                                  <span>{" (" + cand.percentage + "%)"}</span>
                                }
                              </span>
                              <br />
                            </>
                          )}
                          {parseInt(cand.majority) > 0 && (
                            <span className="info_numbers">
                              {localStorage.getItem('lang') != 'zh_TW' ?zhConvertor.t2s("多数票") : "多数票"}:  {parseInt(cand.majority).toLocaleString()}
                            </span>
                          )}
                          {parseInt(cand.invalid) > 0 && (
                            <span className="info_numbers">
                              {localStorage.getItem('lang') != 'zh_TW' ?zhConvertor.t2s("废票") : "废票"}:  {parseInt(cand.invalid).toLocaleString()}
                            </span>
                          )}
                          
                          
                          <div className="bar_chart_container">
                            {cand.candidate.map((eachCandidate, idx) => {
                              const votePercent = ((parseInt(eachCandidate.votes) / parseInt(cand.total_votes)) * 100).toFixed(2);
                              return (
                                <div key={idx} className={`bar_chart_row ${eachCandidate.status === "1" ? "winner" : ""}`}>
                                  {parseInt(eachCandidate.status) > 0 && <span className="winner_label">{getStatusById(eachCandidate.status)}</span>}
                                  <div className="bar_chart_label">
                                    <img src={"https://sabah2025.orientaldaily.com.my/party/"+eachCandidate.alliance_en + ".png"} alt="icon" style={{width:'25px',height:'25px',marginRight:'5px',verticalAlign:'middle'}} />
                                    <span style={{marginRight:'2em'}}>{eachCandidate.party} ({eachCandidate.alliance})</span>
                                    <span>{eachCandidate.candidate_name}</span>
                                  </div>
                                  {parseInt(eachCandidate.votes) > 0 && 
                                    <div className="bar_chart_bar_container">
                                      <div
                                        className="bar_chart_bar"
                                        style={{ width: `${votePercent}%`, backgroundColor: getBgColorByParty(eachCandidate.alliance_en) }}
                                      >
                                        <span className="bar_chart_votes">{eachCandidate.votes.toLocaleString()}</span>
                                      </div>
                                    </div>
                                  }
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    }
                    </Panel>
                  </Collapse>
              </section>
                
              }
            )}
        </div>
        {/*<BackTop>
          <div style={topStyle}><VerticalAlignTopOutlined /></div>
        </BackTop>*/}
         {navigator.share &&
          <div className="floating-share-button" onClick={()=>{
            navigator.share({
              title: '沙巴州选 2025 议席列表 - 东方网 马来西亚东方日报',
              text: '获取马来西亚沙巴州选 2025 的最新消息',
              url: window.location.href
            })
          }}>
            
          </div>
        }
      </div>
    </>
  )
}
export default SeatsDetail